<template>
    <el-form :model="voucher" ref="voucherInfo">
        <template v-if="dbVoucher.deviceFlag && dbVoucher.deviceBound">
            <div class="content-caption dashed">
                <span>换下配件</span>
                <a class="swb-btn-link" @click="selectMountSpecific">选择</a>
            </div>
            <div class="table-layout">
                <el-table :data="voucher.servcWorkAccItemList1" border>
                    <el-table-column prop="accName" label="配件名称" align="left" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span class="swb-tags swb-tags-success">个</span>
                            <span>{{rows.row.accName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="vendorSn" label="厂商序列号" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" width="80" label="操作">
                        <template slot-scope="scope">
                            <a class="swb-btn-link" @click="removeItem1(scope.$index)">移除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </template>
        <div class="content-caption dashed">
            <span>换上配件</span>
            <a class="swb-btn-link" @click="showAccDlg">选择</a>
        </div>
        <div class="table-layout">
            <el-table :data="voucher.servcWorkAccItemList2" border>
                <el-table-column prop="accName" label="配件名称" align="left" width="150" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span class="swb-tags swb-tags-success" v-if="(rows.row.vendorSn != null && rows.row.vendorSn != '') || rows.row.specificFlag">个</span>
                        <span>{{rows.row.accName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="vendorSn" label="厂商序列号" align="left" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="price" label="配件单价" align="right" width="100"></el-table-column>
                <el-table-column label="配件个数" prop="quantity" width="150">
                    <template slot-scope="rows">
                        <div v-if="rows.row.specificFlag == null || rows.row.specificFlag == false || (rows.row.vendorSn != null && rows.row.vendorSn != '')">
                            <div v-if="rows.row.vendorSn == null || rows.row.vendorSn == ''">
                                <el-form-item v-if="rows.row.merchantType == null || rows.row.merchantType == 3" :prop="'servcWorkAccItemList2.' + rows.$index + '.quantity'" :rules="{validator: checkNumber, trigger: 'blur'}">
                                    <el-input type="number" v-model="rows.row.quantity" :min="1" placeholder="请输入配件个数"></el-input>
                                </el-form-item>
                                <span v-else>{{rows.row.quantity}}</span>
                            </div>
                            <div v-else>1</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="unit" label="单位" align="right" width="100"></el-table-column>
                <el-table-column prop="replaceFlag" label="是否更换" width="150">
                    <template slot-scope="rows">
                        <el-radio-group v-model="rows.row.replaceFlag" v-if="rows.row.vendorSn != null && rows.row.vendorSn != ''">
                            <el-radio :label="true" :disabled="rows.row.merchantType == 4">是</el-radio>
                            <el-radio :label="false" :disabled="rows.row.merchantType == 4">否</el-radio>
                        </el-radio-group>
                    </template>
                </el-table-column>
                <el-table-column prop="replaceDesc" label="更换说明">
                    <template slot-scope="rows">
                        <el-input v-model="rows.row.replaceDesc" :disabled="rows.row.merchantType == 4" v-if="rows.row.vendorSn != null && rows.row.vendorSn != '' && rows.row.replaceFlag"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="replaceDesc" label="更换信息" width="150">
                    <template slot-scope="rows">
                        <span v-if="rows.row.replacedVendorSn != null && rows.row.replacedVendorSn != ''">更换了{{rows.row.replacedVendorSn}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="200" label="操作">
                    <template slot-scope="rows">
                        <div v-if="rows.row.merchantType == null || rows.row.merchantType == 3">
                            <a class="swb-btn-link" v-if="rows.row.vendorSn != null && rows.row.vendorSn != '' && rows.row.replaceFlag && voucher.servcWorkAccItemList1.length > 0" @click="replaceSpecific(rows.$index)">匹配换下</a>
                            <a class="swb-btn-link" v-if="(rows.row.vendorSn != null && rows.row.vendorSn != '') || rows.row.specificFlag" @click="selectSpecific(rows.$index)">选择个体配件</a>
                        </div>
                        <a class="swb-btn-link" v-if="(rows.row.vendorSn != null && rows.row.vendorSn != '') || rows.row.merchantType == null || rows.row.merchantType == 3" @click="removeItem2(rows.$index)">移除</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="content-caption dashed">
            <span>备注</span>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="">备注</label>
                </div>
                <div class="form-value width-2x">
                    <el-input type="textarea" v-model="voucher.shareAccMemo"></el-input>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { showShareAccSelect } from '../shareAcc/selectDlg'
    import { openSpecificAccListForSelectDlg } from '../accStock/dialog'

    import servcDelivApi from '../../api/servcDeliv'

    export default {
        name: 'swb-servc-work-share-acc-add',
        props: ['id', 'comId'],
        data: function () {
            return {
                voucher: {
                    id: null,
                    servcWorkAccItemList: [],
                    shareAccMemo: null,
                    servcWorkAccItemList1: [],
                    servcWorkAccItemList2: []
                },
                dbVoucher: {}
            }
        },
        created: function () {
            this.voucher.id = this.id;
            this.getServcWorkVoucher();
        },
        methods: {
            getServcWorkVoucher: function () {
                let self = this;
                let params = {};
                params.id = self.id;
                let theLoad = MsgBox.loading();
                servcDelivApi.getServcWorkVoucherDetail(params, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let dbVoucher = result.data;
                        let servcWorkAccItemList = dbVoucher.servcWorkAccItemList;
                        let servcWorkAccItemList1 = [];
                        let servcWorkAccItemList2 = [];
                        if(servcWorkAccItemList != null && servcWorkAccItemList.length > 0) {
                            servcWorkAccItemList.forEach(function (item) {
                                if(item.mountFlag == -1) {
                                    servcWorkAccItemList1.push(item);
                                } else {
                                    servcWorkAccItemList2.push(item);
                                }
                            });
                        }
                        let voucher = self.voucher;
                        voucher.servcWorkAccItemList1 = servcWorkAccItemList1;
                        voucher.servcWorkAccItemList2 = servcWorkAccItemList2;
                        self.voucher = Utils.merge({}, voucher);
                        self.dbVoucher = dbVoucher;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            checkNumber: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    if(!Utils.isNaturalStr(value, true)) {
                        callback(new Error('请输入正确数量!'));
                    } else {
                        callback();
                    }
                }
            },
            removeItem1(index){
                let servcWorkAccItemList1 = this.voucher.servcWorkAccItemList1;
                servcWorkAccItemList1.removeAt(index);
                this.voucher.servcWorkAccItemList1 = Utils.merge([], servcWorkAccItemList1);
            },
            removeItem2: function (index) {
                let servcWorkAccItemList2 = this.voucher.servcWorkAccItemList2;
                servcWorkAccItemList2.removeAt(index);
                //
                this.voucher.servcWorkAccItemList2 = Utils.merge([], servcWorkAccItemList2);
            },
            showAccDlg(){
                let self = this;
                let voucher = this.voucher;
                let servcWorkAccItemList2 = voucher.servcWorkAccItemList2;
                let accIds = [];
                servcWorkAccItemList2.forEach(function (item) {
                    if(item.mountFlag == 1 && item.shareAccFlag) {
                        accIds.push(item.accId);
                    }
                });
                let comId = this.comId;
                showShareAccSelect([], comId, null, function (stockList) {
                    if(stockList.length > 0) {
                        for(let i = 0; i < stockList.length; i++) {
                            let stock = stockList[i];
                            if(accIds.indexOf(stock.accId) >= 0) {
                                continue;
                            }
                            let servcWorkShareAccItem = {};
                            servcWorkShareAccItem.shareServicerId = stock.servicerId;
                            servcWorkShareAccItem.shareWarehouseId = stock.warehouseId;
                            servcWorkShareAccItem.shareWarehouseName = stock.warehouseName;
                            servcWorkShareAccItem.accId = stock.accId;
                            servcWorkShareAccItem.accName = stock.accName;
                            servcWorkShareAccItem.price = stock.price;
                            servcWorkShareAccItem.catId = stock.catId;
                            servcWorkShareAccItem.catId1 = stock.catId1;
                            servcWorkShareAccItem.catId2 = stock.catId2;
                            servcWorkShareAccItem.catId3 = stock.catId3;
                            servcWorkShareAccItem.brandId = stock.brandId;
                            servcWorkShareAccItem.brandName = stock.brandName;
                            servcWorkShareAccItem.unit = stock.unit;
                            servcWorkShareAccItem.specificFlag = stock.specificFlag;
                            servcWorkShareAccItem.quantity = 1;
                            servcWorkShareAccItem.mountFlag = 1;
                            servcWorkShareAccItem.replaceFlag = false;
                            servcWorkAccItemList2.push(servcWorkShareAccItem);
                        }
                        voucher.servcWorkAccItemList2 = servcWorkAccItemList2;
                        self.voucher = Utils.merge({}, voucher);
                    }
                }, true);
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                result.type = 'wran';
                this.$refs['voucherInfo'].validate(function (valid) {
                    if(valid) {
                        let voucher = self.voucher;
                        let servcWorkAccItemList = Utils.merge([], voucher.servcWorkAccItemList1);
                        let servcWorkAccItemList2 = voucher.servcWorkAccItemList2;
                        if(servcWorkAccItemList2 != null && servcWorkAccItemList2.length > 0) {
                            let accMap = {};
                            for(let i = 0; i < servcWorkAccItemList2.length; i++) {
                                let servcWorkShareAccItem = servcWorkAccItemList2[i];
                                let quantity = parseInt(servcWorkShareAccItem.quantity);
                                if(Utils.isNoB(quantity) || !Utils.isNaturalStr(quantity, true)) {
                                    result.message = "配件个数必须大于0";
                                    return;
                                }
                                if(servcWorkShareAccItem.vendorSn == null || servcWorkShareAccItem.vendorSn == '') {
                                    if(accMap[servcWorkShareAccItem.shareAccFlag + servcWorkShareAccItem.accId] == null) {
                                        accMap[servcWorkShareAccItem.shareAccFlag + servcWorkShareAccItem.accId] = 1;
                                    } else {
                                        result.message = "不能使用多个仓库的同一种配件" + "【" + servcWorkShareAccItem.accName + "】";
                                        return;
                                    }
                                }
                                servcWorkAccItemList.push(servcWorkShareAccItem);
                            }
                        }
                        voucher.servcWorkAccItemList = servcWorkAccItemList;
                        result.data = voucher;
                        result.type = 'info';
                    } else {
                        result.message = "请正确填写信息";
                    }
                });
                return result;
            },
            selectMountSpecific(){
                let self = this;
                let params = {
                    checkBox: true,
                    showTab: false,
                    defActiveName: "relDevc",
                    filter: {
                        boundDevcId: this.dbVoucher.deviceSubNoId,
                        queryAll: true,
                        inUse: true,
                        locked: false
                    }
                };
                openSpecificAccListForSelectDlg(params, function (specificAccList, theDlg) {
                    theDlg.close();
                    let voucher = self.voucher;
                    let servcWorkAccItemList1 = voucher.servcWorkAccItemList1;
                    if(specificAccList != null && specificAccList.length > 0) {
                        specificAccList.forEach(function (selectItem) {
                            selectItem.srcServicerId = selectItem.servicerId;
                            let curItem = servcWorkAccItemList1.find(function (dbItem) {
                                return dbItem.mountFlag == -1 && dbItem.accId == selectItem.accId && dbItem.vendorSn == selectItem.vendorSn && dbItem.srcServicerId == selectItem.srcServicerId;
                            });
                            if(Utils.isNoB(curItem)) {
                                selectItem.accName = selectItem.name;
                                selectItem.quantity = 1;
                                selectItem.mountFlag = -1;
                                servcWorkAccItemList1.push(selectItem);
                            }
                        });
                    }
                    voucher.servcWorkAccItemList1 = servcWorkAccItemList1;
                    self.voucher = Utils.merge({}, voucher);
                });
            },
            replaceSpecific(index){
                let self = this;
                let voucher = this.voucher;
                let servcWorkAccItemList1 = voucher.servcWorkAccItemList1;
                for(let i = 0; i < servcWorkAccItemList1.length; i++) {
                    servcWorkAccItemList1[i].xId = i;
                    servcWorkAccItemList1[i].xName = servcWorkAccItemList1[i].accName + "-" + servcWorkAccItemList1[i].vendorSn;
                }
                let theDlg = Vue.$showDialog({
                    title: '匹配换下',
                    showCloseBtn: true,
                    width: 600,
                    height: 400,
                    template: '<div class="simple-form">' +
                    '   <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label>匹配换下</label>' +
                    '        </div>' +
                    '        <div class="form-value">' +
                    '           <el-select v-model="xId" filterable clearable placeholder="请选择">' +
                    '               <el-option v-for="item in servcWorkAccItemList1" :label="item.xName" :value="item.xId"></el-option>' +
                    '           </el-select>' +
                    '        </div>' +
                    '    </div>' +
                    '</div>',
                    data: {
                        xId: null,
                        servcWorkAccItemList1: servcWorkAccItemList1
                    },
                    methods: {},
                    okClicked: function () {
                        if(this.xId != null) {
                            let item = servcWorkAccItemList1[this.xId];
                            let accItem = self.voucher.servcWorkAccItemList2[index];
                            accItem.replacedAccId = item.accId;
                            accItem.replacedVendorSn = item.vendorSn;
                            accItem.replacedServicerId = item.servicerId || item.shareServicerId;
                            self.voucher = Utils.merge({}, voucher);
                        }
                        return true;
                    }
                });
            },
            selectSpecific(index){
                let voucher = this.voucher;
                let servcWorkAccItemList2 = voucher.servcWorkAccItemList2;
                let accItem = servcWorkAccItemList2[index];
                let self = this;
                let params = {
                    checkBox: true,
                    showTab: false,
                    filter: {
                        retailerComIdx: this.dbVoucher.buyerShopId,
                        accId: accItem.accId,
                        locked: false,
                        bounded: false,
                        shareAccFlag: true
                    }
                };
                openSpecificAccListForSelectDlg(params, function (specificAccList, theDlg) {
                    theDlg.close();
                    let voucher = self.voucher;
                    if(specificAccList != null && specificAccList.length > 0) {
                        for(let i = 0; i < specificAccList.length; i++) {
                            let specificAcc = specificAccList[i];
                            if(accItem.vendorSn == null || accItem.vendorSn == '') {
                                accItem.vendorSn = specificAcc.vendorSn;
                                accItem.srcServicerId = specificAcc.servicerId;
                            } else {
                                // 判断唯一键sn(工程师目前不能用到其他服务提供方的配件)、客户自用配件需判断共享配件提供商
                                specificAcc.srcServicerId = specificAcc.servicerId;
                                let exitItem = servcWorkAccItemList2.find(function (item) {
                                    return item.mountFlag == 1 && item.vendorSn == specificAcc.vendorSn && item.accId == specificAcc.accId && item.srcServicerId == specificAcc.srcServicerId;
                                });
                                if(Utils.isNoB(exitItem)) {
                                    let accItem2 = Utils.merge({}, accItem);
                                    accItem2.vendorSn = specificAcc.vendorSn;
                                    accItem2.srcServicerId = specificAcc.servicerId;
                                    servcWorkAccItemList2.push(accItem2);
                                }
                            }
                        }
                    }
                    voucher.servcWorkAccItemList2 = servcWorkAccItemList2;
                    self.voucher = Utils.merge({}, voucher);
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkShareAccAdd.vue